<template>
  <div align="center" :style="'background-size:cover; background-image:url(../static/img/' + ($vuetify.breakpoint.mdAndUp ? ('hero_md_' + commLocConfig.country_code.toLowerCase() + '.png') : ('hero_sm_' + commLocConfig.country_code.toLowerCase() + '.png')) +'; height:100%;'">
    <v-container grid-list-md fluid fill-height>
      <div :style="$vuetify.breakpoint.smAndUp ? 'position:absolute;top:10%;right:15%' : 'position:absolute;top:60px;right:10px'">
        <v-btn v-for="(comm, c) in config.SUPPORTED_COUNTRIES" :key="c" fab small flat :class="(commCountryCode === comm.country_code ? 'grey lighten-2 ' : '') + 'ma-0'" @click="changeCountry(comm.country_code, comm.country)"><flag style="font-size:16px" :squared="false" :iso="comm.country_code.toLowerCase()"></flag></v-btn>
      </div>
      <v-layout row wrap align-center>
        <v-flex xs12 sm7 md5 class="mx-auto">
          <img height="64" src="/static/img/logo/smartility_admin.png"></img>
          <v-form @submit.prevent="joinComm">
            <v-layout row wrap>
              <v-flex xs12 class="mt-3">
                <v-autocomplete
                :label="'Search & join your community in ' + commLocConfig.country"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                v-model.trim="selComm"
                :no-data-text="search ? 'Community not found in our records' : 'Start typing your community name'"
                hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-btn type="submit" block color="accent">Join</v-btn>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <v-btn block light @click.native="login">Already a member? Log in</v-btn></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-flex xs12 class="mt-4">
            <!-- Not customer yet, would you like to try our app?<br /> -->
            <!-- <v-btn flat class="primary--text" small @click="prepareOnboard">
              Onboard your community
            </v-btn> / -->
            <v-btn flat class="primary--text" small :href="website_url">
              Contact Us
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- join community flow -->
    <join-comm :comm="selComm" :countrycode="commCountryCode" :country="commLocConfig.country" v-if="joining" v-on:closed="joining=false"></join-comm>

    <!-- login flow -->
    <login :countrycode="commCountryCode" v-if="loging" v-on:closed="loging=false"></login>

    <!-- snack bar for error reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import JoinComm from '@/components/JoinComm'
import Login from '@/components/Login'

export default {
  props: ['action'],
  data: () => ({
    gradient: 'to top, rgba(50,50,50, .7), rgba(0,0,0, .7)',
    loading: false,
    comms: [],
    items: [],
    selComm: '',
    search: '',
    joining: false,
    loging: false,
    sbar: false,
    sbarMsg: '',
    sbarCol: 'error',
    config: config,
    commCountryCode: '',
    website_url: 'https://uniservice.in',
    commLocConfig: {country_code: 'IN', country: 'India'}
  }),
  watch: {
    search (val) {
      if (!val) {
        this.selComm = ''
      } else {
        val && val !== this.select && this.querySelections(val)
      }
    }
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    querySelections (v) {
      this.loading = true
      setTimeout(() => {
        this.items = this.comms.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    },
    joinComm () {
      if (this.selComm) {
        // display dialog to join
        this.joining = true
      } else {
        this.msg('Choose a community to join', true)
      }
    },
    login () {
      // display dialog to login
      this.loging = true
    },
    changeCountry (countryCode) {
      this.commCountryCode = countryCode
      this.commLocConfig = config.SUPPORTED_COUNTRIES.find(rec => rec.country_code === countryCode)
      // store locally for further use
      localStorage.setItem('WELCOME_COUNTRY_CODE', countryCode)
      // load communities
      this.loadCommList()
      this.$forceUpdate()
    },
    loadCommList () {
      // load available community from db by country code
      var qry = {
        params: {
          country_code: this.commCountryCode
        }
      }
      this.axios.get(config.API_URL + '/getAvailableCommunity/', qry)
      .then(response => {
        this.comms = response.data.map(rec => rec.comm_name)
        this.querySelections('')
      })
      .catch(err => {
        alert(err.response.data)
      })
    },
    prepareOnboard () {
      this.selComm = ''
      this.joining = true
    }
  },
  created () {
    // find user's country to show localized content
    this.commCountryCode = localStorage.getItem('WELCOME_COUNTRY_CODE')
    if (!this.commCountryCode) {
      this.axios.get('https://ip2c.org/s')
      .then(response => {
        if (response) {
          let resAry = response.data.split(';')
          this.commCountryCode = resAry[1]
          if (config.SUPPORTED_COUNTRIES.findIndex(rec => rec.country_code === this.commCountryCode) < 0) {
            this.commCountryCode = 'IN' // show home country of app when user visits from different countries than supported
          }
          this.changeCountry(this.commCountryCode)
        }
      })
      .catch(err => {
        console.log(err)
        this.changeCountry('IN') // default
      })
    } else {
      this.changeCountry(this.commCountryCode)
    }
    // show join dialog in case new community signup
    if (this.action === 'create') {
      this.prepareOnboard()
    }
  },
  components: {
    'join-comm': JoinComm,
    'login': Login
  }
}
</script>



// WEBPACK FOOTER //
// Welcome.vue?61654ecd